import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, FormattedNumber, FormattedMessage } from 'react-intl';
import { Button, Label } from 'react-bootstrap';

import { addNotification } from 'actions/NotificationsActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';

import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';
import TableResponsive from 'components/layout/TableResponsive';
import SimplePrompt from 'components/layout/SimplePrompt';
import QuotePdfButton from 'components/layout/financial/QuotePdfButton';
import QuoteAuthorizeButton from 'components/layout/financial/QuoteAuthorizeButton';

import QuoteConvertToInvoice from 'components/modals/QuoteConvertToInvoice';
import QuoteConvertFromTemplate from 'components/modals/QuoteConvertFromTemplate';
import QuoteDetails from 'components/modals/QuoteDetails';
import InvoiceDetails from 'components/modals/InvoiceDetails';

import may from 'js/security';
import LeadQuoteNewCopy from 'components/modals/LeadQuoteNewCopy';
import LeadQuoteEdit from 'components/modals/LeadQuoteEdit';

const STATUS_ACTIVE = 'active';
const STATUS_CANCELLED = 'cancelled';

class QuotesList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedQuote: null,
      showConvertFromTemplate: false,
      showConvertToInvoice: false,
      showQuoteDetails: false,
      showInvoice: false,
      showQuoteNewCopy: false,
      quoteToCopy: undefined,
      showQuoteEdit: false,
      quoteToEdit: undefined,
    };
  }

  showConvertFromTemplate = (e, selectedQuote) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ showConvertFromTemplate: true, selectedQuote });
  };

  closeConvertFromTemplate = () => {
    this.setState({ showConvertFromTemplate: false });
  };

  showConvertToInvoice = (e, selectedQuote) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ showConvertToInvoice: true, selectedQuote });
  };

  closeConvertToInvoice = () => {
    this.setState({ showConvertToInvoice: false });
  };

  showQuoteDetails = (e, selectedQuote) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ showQuoteDetails: true, selectedQuote });
  };

  closeQuoteDetails = () => {
    this.setState({ showQuoteDetails: false });
  };

  showInvoice = (e, selectedQuote) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ showInvoice: true, selectedQuote });
  };

  closeInvoice = () => {
    this.setState({ showInvoice: false });
  };

  quoteConvertedToInvoice = () => {
    this.setState({ showConvertToInvoice: false }, () => {
      const {
        intl: { messages },
        doNotify,
      } = this.props;
      doNotify(1, messages.invoice_issued);
    });
  };

  quoteConvertedFromTemplate = () => {
    this.setState({ showConvertFromTemplate: false }, () => {
      const {
        intl: { messages },
        doNotify,
      } = this.props;
      doNotify(1, messages.quote_saved);
    });
  };

  onDelete = quote => {
    const { deleteQuote } = this.props;
    deleteQuote(quote.id);
  };

  copyQuote = (e, quote) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ quoteToCopy: quote }, () => {
      this.setState({ showQuoteNewCopy: true });
    });
  };

  openLead = (e, quote) => {
    e.stopPropagation();
    e.preventDefault();

    const { history, appIntl } = this.props;
    const detailsUrl = appIntl.urlPrefix + 'account/leads/' + quote?.lead.id;
    history.push(detailsUrl);
  };

  editQuote = (e, quote) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ quoteToEdit: quote }, () => {
      this.setState({ showQuoteEdit: true });
    });
  };

  closeQuoteNewCopy = () => {
    this.setState({ showQuoteNewCopy: false });
  };

  closeQuoteEdit = () => {
    this.setState({ showQuoteEdit: false }, () => {
      this.forceUpdate();
    });
  };

  render() {
    const {
      intl: { messages },
      inModal,
      user,
      list,
      quoteTemplates,
    } = this.props;
    const {
      showConvertToInvoice,
      showConvertFromTemplate,
      showInvoice,
      showQuoteDetails,
      showQuoteEdit,
      showQuoteNewCopy,
      selectedQuote,
      quoteToCopy,
      quoteToEdit,
    } = this.state;

    const headers = {
      quoteNumber: messages.quote_number,
      status: messages.status,
      statusIntern: messages.internal_status,
      issued: messages.salesDoc.issued,
      totalDue: messages.salesDoc.total_due,
      actions: messages.actions,
    };

    const rows = [];
    for (let i = 0; i < list.length; i++) {
      const quote = list[i];
      const {
        number,
        number_prefix: numberPrefix,
        sum_gross: sumGross,
        currency,
        cdate,
        doc_template: docTemplate,
        invoice,
        is_auto_generated: isAutoGenerated,
        is_authorized: isAuthorized,
        authorized_on: authorizedOn,
        authorized_by_name: authorizedByName,
        manual_quote_status: manualQuoteStatus,
      } = quote;
      const actions = [<QuotePdfButton quote={quote} key={'pdf' + quote?.id} />];

      let status;
      if (isAutoGenerated) {
        status = <Label bsStyle="info">{messages.auto_generated}</Label>;
      } else if (isAuthorized) {
        status = (
          <Label bsStyle="info">
            <FormattedMessage
              id="authorized_by_name_on_date"
              values={{ name: authorizedByName, date: <IntlDate date={authorizedOn} /> }}
            />
          </Label>
        );
      } else {
        status = <Label bsStyle="info">{messages.not_authorized}</Label>;
        actions.push(<QuoteAuthorizeButton key="authorizeQuote" quoteId={quote.id} />);
        actions.push(<SimplePrompt key="deleteQuote" onSuccess={() => this.onDelete(quote)} />);
      }

      let internalStatus;
      if (manualQuoteStatus === STATUS_ACTIVE) {
        internalStatus = <Label bsStyle="info">{messages.active_quote}</Label>;
      }
      if (manualQuoteStatus === STATUS_CANCELLED) {
        internalStatus = <Label bsStyle="info">{messages.canceled_quote}</Label>;
      }

      if (
        (!quoteTemplates.pending && (!docTemplate && quoteTemplates.data.count)) ||
        (docTemplate && quoteTemplates.data.count > 1)
      ) {
        actions.push(
          <a
            href="#convertFromTemplate"
            className="btn-rounded btn btn-sm btn-default"
            key="convertFromTemplate"
            onClick={e => this.showConvertFromTemplate(e, quote)}
          >
            {messages.use_document_template}
          </a>
        );
      }

      if (!invoice) {
        if ((isAutoGenerated || isAuthorized) && may('ROLE_ACC_INVOICE', user.roles)) {
          actions.push(
            <>
              <a
                href="#convertToInvoice"
                className="btn-rounded btn btn-sm btn-default"
                key="convertToInvoice"
                onClick={e => this.showConvertToInvoice(e, quote)}
              >
                {messages.convert_to_invoice}
              </a>
              <Button
                bsSize="sm"
                bsStyle="warning"
                className="btn-rounded"
                onClick={e => {
                  this.editQuote(e, quote);
                }}
              >
                <i className="fa fa-pencil-alt" /> {messages.edit}
              </Button>
            </>
          );
        }
      } else {
        actions.push(
          <a
            href="#showInvoice"
            className="btn-rounded btn btn-sm btn-default"
            key="showInvoice"
            onClick={e => this.showInvoice(e, quote)}
          >
            {messages.show_invoice}
          </a>
        );
      }
      actions.push(
        <>
          <Button
            bsSize="sm"
            bsStyle="danger"
            className="btn-rounded"
            onClick={e => {
              this.copyQuote(e, quote);
            }}
          >
            <i className="fas fa-copy" /> {messages.copy}
          </Button>
          <Button
            bsSize="sm"
            bsStyle="success"
            className="btn-rounded"
            onClick={e => {
              this.openLead(e, quote);
            }}
          >
            <i className="fa fa-gem" /> {messages.open_lead}
          </Button>
        </>
      );

      const rowData = {
        quoteNumber: '#' + (numberPrefix || '') + (number || '?'),
        status,
        internalStatus,
        issued: <IntlDate date={cdate} />,
        totalDue: <FormattedNumber value={sumGross} style="currency" currency={currency} />,
        actions,
        onClick: e => this.showQuoteDetails(e, quote),
      };

      rows.push(rowData);
    }

    return list.pending ? (
      <Loader />
    ) : (
      <React.Fragment>
        {!inModal ||
        (inModal && !showConvertFromTemplate && !showConvertToInvoice && !showQuoteDetails && !showInvoice) ? (
          <TableResponsive headers={headers} rows={rows} hover />
        ) : null}

        <QuoteConvertToInvoice
          alreadyInModal={inModal}
          show={showConvertToInvoice}
          close={this.closeConvertToInvoice}
          quote={selectedQuote}
          onSubmitParent={this.quoteConvertedToInvoice}
        />
        <QuoteConvertFromTemplate
          alreadyInModal={inModal}
          show={showConvertFromTemplate}
          close={this.closeConvertFromTemplate}
          quote={selectedQuote}
          onSubmitParent={this.quoteConvertedFromTemplate}
        />
        <QuoteDetails
          alreadyInModal={inModal}
          show={showQuoteDetails}
          close={this.closeQuoteDetails}
          quote={selectedQuote}
        />
        <InvoiceDetails
          alreadyInModal={inModal}
          show={showInvoice}
          close={this.closeInvoice}
          invoiceId={selectedQuote ? selectedQuote.invoice : null}
        />
        <LeadQuoteNewCopy
          quote={quoteToCopy}
          show={showQuoteNewCopy}
          close={this.closeQuoteNewCopy}
          key="quote-new-copy-popup"
        />
        <LeadQuoteEdit
          quote={quoteToEdit}
          show={showQuoteEdit}
          close={this.closeQuoteEdit}
          key="quote-new-edit-popup"
        />
      </React.Fragment>
    );
  }
}
QuotesList.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    quoteTemplates: state.list.quoteTemplates,
    quoteDeleter: state.deleter.quote,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    deleteQuote: quoteId => {
      deleterDispatchHelper('quote', `/api/quotes/${quoteId}.json`, dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(QuotesList)
  )
);
